import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

enableProdMode();

platformBrowser().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main-AOT.ts